import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext.jsx';

export default function RequirePassword({ children }) {
  const { user } = useAuth();
  if (user?.mustChangePassword) return <Navigate to="/change-password" replace />;
  return children;
}
